import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../../../osp-ui/components/button/button/button.component';
import { ConfirmationService } from '../../../../../../osp-ui/services/confirmation.service';
import { LanguageService } from '../../../../../services/language.service';

@Component({
  selector: 'osp-acknowledge-all-button',
  standalone: true,
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './acknowledge-all-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcknowledgeAllNotificationsButtonComponent {
  private readonly confirmationService = inject(ConfirmationService);
  private readonly languageService = inject(LanguageService);

  acknowledgeCb = input<() => unknown>();
  $disabled = input<boolean>(false, { alias: 'disabled' });
  $loading = input<boolean>(false, { alias: 'loading' });

  handleClick(): void {
    this.confirmationService.confirm({
      header: this.translate('modules.notifications.confirmAcknowledgeAllDialog.title'),
      message: this.translate('modules.notifications.confirmAcknowledgeAllDialog.message'),
      acceptLabel: this.translate('general.buttons.confirm'),
      rejectLabel: this.translate('general.buttons.cancel'),
      accept: () => {
        this.acknowledgeCb()?.(); // acknowledgeCb is an InputSignal<() => unknown>;
      },
    });
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
